import AxiosBaseService from "./axiosBaseService";
import axios from "axios";

export default class AxiosAudioService extends AxiosBaseService {

  // GET: list out all recordings
  getAudioList(token: string, userId:string) {
    return this.get(`${this.serverUrl}/audio_recording/user/${userId}`, {authToken: token});
  }

  // GET: list out all recordings by Group
  getGroupAudioList(token:string, groupId:string){
    return this.get(`${this.serverUrl}/audio_recording/group/${groupId}`, {authToken: token})
  }

  // POST: create a new audio
  createAudio(token: string, audioData: any, contentType:string) {
    console.log("audioData: ", audioData); // Accessing the value directly
    return this.post(`${this.serverUrl}/audio_recording`, audioData, {
      authToken: token
    }, contentType);
  }
 
  // PATCH: update Org data
  editAudio(token: string, recordId:string, title:any) {
    return this.patch(`${this.serverUrl}/audio_recording/${recordId}`, title, {
      authToken: token
    });
  }

  // DELETE: delete audio
  deleteAudio(token: string, recordId: string){
    return this.delete(`${this.serverUrl}/audio_recording/${recordId}`, {authToken: token})
  }

  // GET: download audio
  downloadAudio(token: string, storage:string) {
    console.log("Enter DownlaodAudio!: ", storage)

    return this.get(`${this.serverUrl}/audio_recording/audio_file/${storage}`, {
      authToken: token
    });
  }
}